export default "__VITE_ASSET__ffea0ca4__"